/*eslint-disable*/
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Button } from "@material-ui/core";
import Lottie from "react-lottie";
import GoodBehaviorAnimation from "../../../animations/lottie_good_behavior.json";

const useStyles = makeStyles((theme) => ({
  gridMain: {
    // width: "100%",
    // margin: "auto",
    marginTop: "5%",
    // backgroundColor: "red",
  },
}));

export default function NotReportsFound(props) {
  const classes = useStyles();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: GoodBehaviorAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      className={classes.gridMain}
    >
      <Grid container direction="column" alignItems="center">
        <Lottie options={defaultOptions} height={300} width={300} />
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 26,
            fontWeight: 500,
            color: "#fff",
          }}
        >
          Sin reportes de conducta
        </Typography>
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 18,
            color: "#acacac",
          }}
        >
          Este empleado no tiene registrado ningún reporte de conducta
        </Typography>
      </Grid>
    </Grid>
  );
}
